import { useEffect, useRef, useState } from "react";
import Product1 from '../Img/Product1.png';
import Product2 from '../Img/Product2.png';
import { useNavigate } from "react-router-dom";

const OfferCard = ({ image, title, description, link }) => {
  const navigate = useNavigate();
  return (
    <div className="offer-card">
      <div className="image-container">
        <img src={image} alt={title} />
      </div>
      <div className="card-content">
        <h2 className="offer-heading">Limited Time Offer!</h2>
        <h3>{title}</h3>
        <p className="offer-description">{description}</p>
        {link && (
          <button className="offer-btn" onClick={() => window.location.href = link}>
            <i className="fas fa-gift"></i> Claim Your Offer
          </button>
        )}
      </div>
    </div>
  );
};

export default function OfferCards() {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [offers, setOffer] = useState([]);
  const url = process.env.REACT_APP_API_URL;

  const updateScrollVisibility = () => {
    const el = scrollRef.current;
    if (el) {
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
    }
  };

  const sliderFetch = async () => {
    try {
      const response = await fetch(`${url}/offer/all/${process.env.REACT_APP_PERFUME_ID}`);
      const res = await response.json();
      setOffer(res.reverse());
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    sliderFetch();
  }, []);

  useEffect(() => {
    updateScrollVisibility();
    const el = scrollRef.current;
    if (el) {
      el.addEventListener("scroll", updateScrollVisibility);
    }
    window.addEventListener("resize", updateScrollVisibility);
    return () => {
      if (el) el.removeEventListener("scroll", updateScrollVisibility);
      window.removeEventListener("resize", updateScrollVisibility);
    };
  }, [offers]);

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -250, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 250, behavior: "smooth" });
  };

  return (
    <>
      {
        offers.length > 0 && (
          <div className="offer-wrapper">
            {canScrollLeft && (
              <div className="category-images-scroll-chevron category-images-scroll-chevron-left" onClick={scrollLeft}>
                <i className="fas fa-chevron-left"></i>
              </div>
            )}

            <div className="offer-container" ref={scrollRef}>
              {offers.map((offer, index) => (
                <OfferCard key={index} {...offer} />
              ))}
            </div>

            {canScrollRight && (
              <div className="category-images-scroll-chevron category-images-scroll-chevron-right" onClick={scrollRight}>
                <i className="fas fa-chevron-right"></i>
              </div>
            )}
          </div>
        )
      }
    </>

  );
}
